import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './UsageLoading.Config.Styles';

const headerLoadingConfig = [
  {
    left: setLoadingConfigObject('line', 1, 180, styles.headerStyle),
    right: setLoadingConfigObject('line', 1, 60, styles.headerStyle),
    containerStyle: styles.headerContainerStyle,
  },
  {
    left: setLoadingConfigObject('line', 1, 160, styles.subHeaderStyle),
    containerStyle: styles.subheaderContainerStyle,
  },
];

const tabsLoadingConfig = [
  {
    main: [
      'row',
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle),
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle),
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle),
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle),
    ],
    containerStyle: styles.tabsContainerStyle,
  },
];

const percentageViewLoadingConfig = [
  {
    containerStyle: styles.usageBodyItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.usageBodyItemCircle),
    main: setLoadingConfigObject('square', 2, null, styles.usageBodyItemSquare),
  },
  {
    containerStyle: styles.usageBodyItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.usageBodyItemCircle),
    main: setLoadingConfigObject('square', 2, null, styles.usageBodyItemSquare),
  },
  {
    containerStyle: styles.usageBodyItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.usageBodyItemCircle),
    main: setLoadingConfigObject('square', 2, null, styles.usageBodyItemSquare),
  },
];

const graphViewFooterLoadingConfig = theme => [
  {
    style: styles.separatorTwo(theme),
  },
  {
    containerStyle: styles.usageBodyOnlyItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.usageBodyItemCircle),
    main: setLoadingConfigObject('square', 2, null, styles.usageBodyItemSquare),
  },
];

const graphViewLoadingConfig = (withGraphViewFooter, theme) => [
  {
    left: setLoadingConfigObject('line', 1, 65, styles.totalStyle),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.graphStyle),
  },
  ...(withGraphViewFooter ? graphViewFooterLoadingConfig(theme) : []),
];

const loadingConfig = (withPercentageView, withGraphViewFooter, theme) => [
  {
    left: setLoadingConfigObject('line', 1, 65, styles.titleStyle),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.dateStyle),
    ...(withPercentageView
      ? {}
      : { right: setLoadingConfigObject('line', 1, 60, styles.usageStyle) }),
  },
  {
    style: styles.separator(theme),
  },
  ...(withPercentageView
    ? percentageViewLoadingConfig
    : graphViewLoadingConfig(withGraphViewFooter, theme)),
];

export { headerLoadingConfig, tabsLoadingConfig, loadingConfig, shimmerPlaceholderConfig };
